/**
 * Worin die Beraterübersicht sucht. Die Reihenfolge ist zugleich die Reihenfolge der
 * Auswahlliste — „Alle Felder" steht immer zuletzt.
 */
export const SEARCH_SCOPES = ['name', 'pos', 'firma', 'alle'] as const;

export type SearchScope = (typeof SEARCH_SCOPES)[number];

export const DEFAULT_SEARCH_SCOPE: SearchScope = 'name';

/** Ein unbekannter oder fehlender Wert fällt stillschweigend auf „Name" zurück. */
export function toSearchScope(value: string | null | undefined): SearchScope {
  return SEARCH_SCOPES.includes(value as SearchScope)
    ? (value as SearchScope)
    : DEFAULT_SEARCH_SCOPE;
}

/**
 * Der Suchbegriff aus der Adresse. Steht ein Parameter mehrfach darin (`?q=a&q=b`), liefert
 * Angular ein Array; ein solcher Wert ist nicht eindeutig und faellt wie bei `toSearchScope`
 * stillschweigend auf den Standard zurueck — hier auf den leeren Begriff.
 */
export function toSearchTerm(value: unknown): string {
  return typeof value === 'string' ? value : '';
}
